import useVoyadoTrackCart from "../hooks/useVoyadoTrackCart";

const VoyadoCartTracker = ({ cart }) => {
   useVoyadoTrackCart({cart});
   return null; // This component only tracks the cart, so no UI is needed.
 };
 
 export default VoyadoCartTracker;